export class Reservation
{
	reservationId: number;
	reservationDate: Date;
}
